// extracted by mini-css-extract-plugin
export default {"nearDeadlineRow":"ExamsTab_nearDeadlineRow__6Fz0p","expiredDeadlineRow":"ExamsTab_expiredDeadlineRow__M3+dP"};